export default __webpack_public_path__ + "static/media/img8.97a0393a.jpg";